import { render, staticRenderFns } from "./ListSalesOrderPage.vue?vue&type=template&id=1fd5f656"
import script from "./ListSalesOrderPage.vue?vue&type=script&lang=js"
export * from "./ListSalesOrderPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports